export default __webpack_public_path__ + "static/media/FMSf-03.ed162d88.png";